function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Datepicker } from "../../../native";
import * as D from 'unitx/date';
import * as R from 'unitx/ramda';
// import { setUninitializedValue } from '../../utils'
import { useFormContext } from "../FormContext";

const DatepickerWidget = ({
  schema,
  id,
  // options,
  label,
  disabled,
  readonly,
  value,
  onChange,
  onBlur,
  onFocus,
  formContext // required,

}) => {
  // const { min, max } = options
  const {
    mapping
  } = useFormContext(formContext);
  const uninitialized = R.isNotValidDate(new Date(value));
  const processedValue = uninitialized ? new Date() : new Date(value); // @TODO:TEST
  // React.useMemo(() => {
  //   setUninitializedValue({
  //     required,
  //     getDefault: () => D.format('yyyy-MM-dd')(processedValue),
  //     condition: uninitialized,
  //     onChange,
  //   })
  // }, [])
  // @TODO:TEST_END

  return /*#__PURE__*/React.createElement(Datepicker, _extends({}, mapping.datepicker, {
    style: [mapping.datepicker.style],
    label: label !== null && label !== void 0 ? label : schema.title,
    date: processedValue // value ? new Date(value) :
    // {...(min ? { min: new Date(min) } : {})}
    // {...(max ? { max: new Date(max) } : {})}
    // required={required}
    ,
    disabled: disabled || readonly // autoFocus={autofocus}
    ,
    onSelect: date => onChange(D.format('yyyy-MM-dd')(date)),
    onBlur: () => onBlur(id, value),
    onFocus: () => onFocus(id, value)
  }));
};

export default DatepickerWidget;